import React, { useEffect } from 'react';
import { Text, Stack } from 'basis';
import { LayoutForm } from 'components/layout-form/LayoutForm';
import { LayoutPage } from 'components/layout-page/LayoutPage';

export const SessionExpired: React.FC = () => {
  // Prevent back navigation from expired page
  useEffect(() => {
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <LayoutPage step="update" hideProgressStepper inactivityTimeout={false}>
      <LayoutForm>
        <Stack gap="8">
          <Text as="h1" textStyle="heading5" textStyle-md="heading4">
            Session expired
          </Text>
          <Text>Your session has expired due to inactivity.</Text>
        </Stack>
      </LayoutForm>
    </LayoutPage>
  );
};
